import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load dashboard layout
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const AlertDefinitionLayout = lazy(() => import('@/pages/alerts/definitions/[alertDefinitionId]/layout'));
const AlertAcknowledgeLayout = lazy(() => import('@/pages/alerts/acknowledges/[alertDefinitionId]/layout'));

// Lazy load alert pages
const AlertAcknowledgesPage = lazy(() => import('@/pages/alerts/acknowledges'));
const AlertAcknowledgeDetailPage = lazy(() => import('@/pages/alerts/acknowledges/[alertDefinitionId]/details'));
const AlertDefinitionsPage = lazy(() => import('@/pages/alerts/definitions'));
const CreateAlertDefinitionPage = lazy(() => import('@/pages/alerts/definitions/create'));
const AlertDefinitionDetailPage = lazy(() => import('@/pages/alerts/definitions/[alertDefinitionId]/details'));
const UpdateAlertDefinitionPage = lazy(() => import('@/pages/alerts/definitions/[alertDefinitionId]/update'));

/**
 * Alert routes
 * Handles alert acknowledgments and definitions
 */
export const alertRoutes: RouteConfig = {
  path: '/alerts',
  layout: DashboardLayout,
  children: [
    {
      path: '/acknowledges',
      element: AlertAcknowledgesPage,
    },
    {
      path: '/acknowledges/:alertDefinitionId',
      layout: AlertAcknowledgeLayout,
      children: [
        {
          path: '/details',
          element: AlertAcknowledgeDetailPage,
        },
      ],
    },
    {
      path: '/definitions',
      element: AlertDefinitionsPage,
    },
    {
      path: '/definitions/create',
      element: CreateAlertDefinitionPage,
    },
    {
      path: '/definitions/:alertDefinitionId',
      layout: AlertDefinitionLayout,
      children: [
        {
          path: '/details',
          element: AlertDefinitionDetailPage,
        },
        {
          path: '/update',
          element: UpdateAlertDefinitionPage,
        },
      ],
    },
  ],
};
